export function getPointsToSelectNow(status = false) {
  return {
    type: 'GET_POINTS_TO_SELECT_NOW',
    status 
  }
}